import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {MasterVehicle} from '../../common/actionTypes';

const INITIAL_STATE = {
  'loadingColors': false,
  'outdoorColorList': [],
  'loadingCommentsByChassis': false,
  'commentsByChassis': [],
};

export const qualityAssuranceOrderCreate = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [MasterVehicle.FETCHING_JDE_PARAMETERS]: (state, action) => ({
      ...state,
      'loadingColors': true,
    }),
    [MasterVehicle.FETCHED_JDE_PARAMETERS]: (state, action) => ({
      ...state,
      'loadingColors': false,
      'outdoorColorList': action.response.data.outdoorColorList,
    }),
    [MasterVehicle.FETCHED_JDE_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'loadingColors': false,
      'outdoorColorList': [],
    }),
    [ActionTypes.FETCHING_COMMENTS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingCommentsByChassis': true,
    }),
    [ActionTypes.FETCHED_COMMENTS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingCommentsByChassis': false,
      'commentsByChassis': action.response.data,
    }),
    [ActionTypes.FETCHED_COMMENTS_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loadingCommentsByChassis': false,
      'commentsByChassis': [],
    }),
  })(state, action);
};
